import React from 'react';

function PopupMenu({ children, width, height }) {
  const modalStyle = {
    ...styles.modal,
    width: width || '60%',
    height: height || undefined,
    maxWidth: width ? undefined : '700px',
    maxHeight: height ? undefined : '500px',
  };
  return (
    <div style={styles.overlay}>
      <div style={modalStyle}>
        {children}
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    },
  modal: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    position: 'relative',
    overflowY: 'auto',
  }
};

export default PopupMenu;